import { Field } from '@docma-mm-core/field/field';
import { FieldDataTypeEnum } from '@docma-mm-core/field/field-data-type.enum';
import { MydocmaDatePipe } from '@mydocma/common';
import { TranslateService } from '@ngx-translate/core';
import { FilterLinkOperatorEnum } from './filter-link-operator.enum';
import { FilterOperatorEnum } from './filter-operator.enum';


export class FilterCriteria {

  readonly operationToStringMap = new Map< FilterOperatorEnum, string>(
    [
      [FilterOperatorEnum.Greater, '>'],
      [FilterOperatorEnum.GreaterEqual, '>='],
      [FilterOperatorEnum.IsFalse, 'nicht gesetzt'],
      [FilterOperatorEnum.IsTrue, 'gesetzt '],
      [FilterOperatorEnum.Less, '<'],
      [FilterOperatorEnum.LessEqual, '<='],
      [FilterOperatorEnum.Like, ':'],
      [FilterOperatorEnum.NotEqual, '!='],
      [FilterOperatorEnum.Equal, ':'],
  ]);


  constructor(init?: Partial<FilterCriteria>) {
    if (init) {
      Object.assign(this, init);
      if (this.Field) {
        this.Field = { Id: this.Field.Id, DefaultName: this.Field.DefaultName };
      }
    }
  }

  Id?: number;
  ParentId?: number;
  Field: Field;
  LinkOperator: FilterLinkOperatorEnum = 0;
  LogicalOperator: FilterOperatorEnum;
  ListFilter: boolean = false;
  ComparativeValue: any;
  ComparativeValue2: any;
  text: string;
  selectedId: number;

  SearchGroupUid?: string;
  NoGroupLabel?: boolean;

  toString( datePipe: MydocmaDatePipe, translateService: TranslateService): string {
    const addSpaceWhenNeeded = (this.LogicalOperator == FilterOperatorEnum.Equal || this.LogicalOperator == FilterOperatorEnum.Like) ? '' : ' ';
    if(this.Field.DataType === FieldDataTypeEnum.DateTime) {
      return `${this.Field.GlobalName}${addSpaceWhenNeeded}${this.operationToStringMap.get(this.LogicalOperator)} ${this.ComparativeValue === null ? '' : datePipe.transform(this.ComparativeValue)}`;
    } else if(this.LogicalOperator === FilterOperatorEnum.IsFalse || this.LogicalOperator === FilterOperatorEnum.IsTrue) {
      return `${this.Field.GlobalName}${addSpaceWhenNeeded}${this.operationToStringMap.get(this.LogicalOperator)}`;
    } else {
      return `${this.Field.GlobalName}${addSpaceWhenNeeded}${this.operationToStringMap.get(this.LogicalOperator)} ${this.ComparativeValue === null ? '' : (this.text ? translateService.instant(this.text) : this.ComparativeValue)}`;
    }
  }

}
